function MatcherErrorText({ errorText }: Readonly<{ errorText?: string }>) {
  return (
    errorText && (
      <div data-testid="matcher_error_text" className="text-2 text-red-60">
        {errorText}
      </div>
    )
  );
}

export { MatcherErrorText };
